import { TileBlockingRect } from "../../tile_blocking_geometry"

// Visible bounds of the wooden roof autotiles in fence_medieval (32px atlas cells).
// Edge artwork has transparent margins; those pixels cannot support the next storey.
const roofBounds: Record<number, [number, number, number, number]> = {
    448: [4, 7, 32, 32], 449: [0, 7, 32, 32], 450: [0, 7, 28, 32],
    451: [4, 7, 32, 32], 452: [0, 7, 32, 27], 453: [0, 7, 28, 32],
    454: [0, 7, 28, 27], 455: [4, 7, 32, 27],
    464: [5, 0, 32, 32], 465: [0, 0, 32, 32], 466: [0, 0, 27, 32],
    467: [5, 0, 29, 32], 468: [4, 6, 26, 25], 469: [3, 0, 27, 23],
    480: [4, 0, 32, 25], 481: [0, 0, 32, 25], 482: [0, 0, 28, 25],
    483: [4, 0, 32, 25], 484: [0, 0, 28, 25], 485: [3, 9, 27, 32],
}

export interface ExposedSupportEdges { left: boolean; top: boolean; right: boolean; bottom: boolean }
export const SUPPORT_EDGE_INSET = 12

export const roofVisibleBounds = (tilesetId: string, position: number): [number, number, number, number] =>
    (tilesetId === "fence_medieval" ? roofBounds[position] : undefined) ?? [0, 0, 32, 32]

export const roofSupportMargins = (tilesetId: string, position: number, exposed: ExposedSupportEdges): TileBlockingRect[] => {
    const bounds = roofVisibleBounds(tilesetId, position)
    let [left, top, right, bottom] = bounds
    // Inset only the visible outline. Interior joins remain continuous.
    if (left > 0 || exposed.left) left += SUPPORT_EDGE_INSET
    if (top > 0 || exposed.top) top += SUPPORT_EDGE_INSET
    if (right < 32 || exposed.right) right -= SUPPORT_EDGE_INSET
    if (bottom < 32 || exposed.bottom) bottom -= SUPPORT_EDGE_INSET
    const rects: TileBlockingRect[] = []
    if (left) rects.push({ x: 0, y: 0, width: left, height: 32, groundSupport: true })
    if (right < 32) rects.push({ x: right, y: 0, width: 32 - right, height: 32, groundSupport: true })
    if (top) rects.push({ x: 0, y: 0, width: 32, height: top, groundSupport: true })
    if (bottom < 32) rects.push({ x: 0, y: bottom, width: 32, height: 32 - bottom, groundSupport: true })
    return rects
}
